import { useWebSocket } from "@/react/hooks/useWebSocket";

import { useMemberDeactivated } from "./useMemberDeactivated";

interface UseCommunityMemberThreadsChannelWebSocketProps {
  canCreateConnection?: boolean;
  communityMemberId: number | undefined;
  deps?: unknown[];
  onMessageReceive: (data: any) => void;
}

export const useCommunityMemberThreadsChannelWebSocket = ({
  communityMemberId,
  onMessageReceive,
  canCreateConnection = true,
  deps = [],
}: UseCommunityMemberThreadsChannelWebSocketProps) => {
  const { isDeactivated, onMemberDeactivatedEvent } =
    useMemberDeactivated(communityMemberId);

  useWebSocket(
    {
      channel: "Chats::CommunityMemberThreadsChannel",
      // communityMemberId is passed as contact_id because CommunityMember inherits
      // from Contact and shares the same numeric ID. The channel accepts both keys
      // via resolved_contact_param_id; contact_id is the preferred Phase 2+ param.
      contact_id: communityMemberId,
      onMessageReceive: (data: any) => {
        onMemberDeactivatedEvent(data);
        if (data.event !== "memberDeactivated") {
          onMessageReceive(data);
        }
      },
      canCreateConnection:
        canCreateConnection && Boolean(communityMemberId) && !isDeactivated,
    },
    [communityMemberId, canCreateConnection, isDeactivated, ...deps],
  );
};
